<template>
	<div :id="displayMenuWrapper()">
		<div class="menu-nav-warpper" v-if="displayMenu()">
			<div class="menuNav">
				<div :class="getActiveMenu('sales')">
					<router-link to="/sales">
						<div class="icon-text">
							<ios-cart-icon w="32px" h="32px" />
							<span>POS</span>
						</div>
					</router-link>
				</div>

				<div :class="getActiveMenu('orderList')">
					<router-link to="/orders">
						<div class="icon-text">
							<ios-list-icon w="32px" h="32px" />
							<span>Orders</span>
						</div>
					</router-link>
				</div>

				<div :class="getActiveMenu('productsList')">
					<router-link to="/products">
						<div class="icon-text">
							<ios-apps-icon w="32px" h="32px" />
							<span>Products</span>
						</div>
					</router-link>
				</div>

				<div :class="getActiveMenu('exportOrders')">
					<router-link to="/export-orders">
						<div class="icon-text">
							<ios-analytics-icon w="32px" h="32px" />
							<span>Export</span>
						</div>
					</router-link>
				</div>

				<div :class="getActiveMenu('backdate')">
					<router-link to="/backdate">
						<div class="icon-text">
							<ios-calendar-icon w="32px" h="32px" />

							<span>Backdate</span>
						</div>
					</router-link>
				</div>

				<div :class="getActiveMenu('members')">
					<router-link to="/members">
						<div class="icon-text">
							<ios-people-icon w="32px" h="32px" />

							<span>Members</span>
						</div>
					</router-link>
				</div>

				<div :class="getActiveMenu('settings')">
					<router-link to="/settings">
						<div class="icon-text">
							<ios-settings-icon w="32px" h="32px" />

							<span>Settings</span>
						</div>
					</router-link>
				</div>

				<div class="menuIcons">
					<span @click="logoutConfirm" class="hyperlink">
						<div class="icon-text">
							<ios-log-out-icon w="32px" h="32px" />
							<span>Logout</span>
						</div>
					</span>
				</div>

				<div :class="onlineStatus()">{{ onlineStatus() }}</div>
			</div>
		</div>

		<div class="main">
			<router-view />
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'App',
	data: function() {
		return {
			displayNav: true,
			online: false,
			timer: ''
		}
	},
	watch: {
		'$store.state.serverSetting': function(newVal) {
			this.$axios.defaults.baseURL = newVal
		}
	},

	mounted: function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		if (this.$store.state.serverSetting) {
			this.$axios.defaults.baseURL = this.$store.state.serverSetting
		}

		this.getOnlineStatus()
		this.timer = setInterval(this.getOnlineStatus, 20000)
	},

	created: function() {
		// Set auth if exist
	},

	methods: {
		onlineStatus: function() {
			if (this.online) {
				return 'online'
			} else {
				return 'offline'
			}
		},

		// Get brach info
		getOnlineStatus: async function() {
			if (this.$store.state.auth) {
				// Get data from info api
				try {
					const apiInfo = await this.$api.branchInfo()

					if (apiInfo) {
						// Assign data
						const onlineStatus = apiInfo.data['static-values'].configs.system.online

						this.online = onlineStatus
					} else {
						this.online = false
					}
				} catch (e) {
					this.online = false
				}
			}
		},

		// Hide or display menu
		displayMenuWrapper: function() {
			if (this.$router.currentRoute.name == 'login') {
				return 'app-single'
			} else {
				return 'app'
			}
		},

		// Hide nav bar in other pages
		displayMenu: function() {
			if (this.$router.currentRoute.name !== 'login') {
				return true
			}
		},

		// This will set css class active if menu is active
		getActiveMenu: function(menu) {
			if (menu == this.$router.currentRoute.name) {
				return 'menuIcons active'
			}

			return 'menuIcons'
		},

		logoutConfirm: function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to logout?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, Logout!'
				})
				.then(result => {
					if (result.value) {
						this.$router.push({ name: 'logout' })
					}
				})
		}
	}
}
</script>

<style>
@import url('https://cdn.materialdesignicons.com/2.5.94/css/materialdesignicons.min.css');

/* @font-face {
	font-family: poppins;
	src: url('./assets/fonts/poppins.ttf');
}

@font-face {
	font-family: poppinsMedium;
	src: url('./assets/fonts/poppins-Medium.ttf');
} */

@font-face {
	font-family: poppins;
	src: url('./assets/fonts/Poppins.ttf');
}

@font-face {
	font-family: poppinssemibold;
	src: url('./assets/fonts/PoppinsSemiBold.ttf');
}

@font-face {
	font-family: poppinsbold;
	src: url('./assets/fonts/PoppinsBold.ttf');
}

body {
	margin: 0;
	font-size: 14px;
}

#app {
	font-family: 'poppins', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #1c2d40;
	background-color: #f6f9fd;
	width: 100%;
	min-height: 100vh;
	display: grid;
	grid-template-columns: 90px 1fr;
}

#app-single {
	font-family: 'poppins', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #1c2d40;
	background-color: #f6f9fd;
	width: 100%;
	min-height: 100vh;
	background-color: #62c7c2;
}

.online {
	width: 50px;
	margin: 20px auto 0;
	font-family: poppinsbold;
	font-size: 13px;
	color: #fff;
	background: #4abb00;
	padding: 5px;
	border-radius: 3px;
}

.offline {
	width: 50px;
	margin: 20px auto 0;
	font-family: poppinsbold;
	font-size: 13px;
	color: #fff;
	background: #ff4343;
	padding: 5px;
	border-radius: 3px;
}

.order-list h3,
.products-list h3 {
	font-weight: bold;
	font-size: 21px;
	color: #000;
	margin-bottom: 20px;
}

.menu-nav-warpper {
	margin-right: 10px;
	background-color: #f6f9fd;
}

.menuNav {
	background-color: #fff;
	color: #9a9a9a;
	font-size: 20px;
	-webkit-box-shadow: 0px 0px 5px 0px rgb(201, 238, 250);
	-moz-box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	height: 100%;
	margin: 0;
	padding: 0;
}

.menuIcons .ion {
	margin: auto;
}

.icon-text {
	text-align: center;
	display: grid;
	grid-template-rows: 45px 20px;
}

.menuNav .menuIcons {
	padding-top: 14px;
	color: #9a9a9a;
}

.menuIcons span {
	font-size: 11px;
}

.main {
	width: 100%;
	height: 100%;
}

.menuNav a {
	color: #9a9a9a;
}

.menuNav .active a {
	color: #1c2d40;
}

.blank-nav-wrapper {
	background-color: #62c7c2;
}

.menuNav .active span {
	font-family: 'poppinssemibold';
}

.menuNav a:hover {
	color: #1c2d40;
}

.paginationWrapper {
	margin: auto;
}

.pager .pagination {
	width: 400px;
	border-radius: 40px;
	border: 1px solid #ccc;
	margin: auto;
	padding: 5px 20px;
	font-weight: bold;
}

.pager .pagination a {
	color: #999;
	padding: 6px 12px;
	line-height: 1.42;
	font-size: 13px;
}

.pager .pagination .active a {
	color: #999;
	padding: 0;
	outline: 0;
}

.pager .pagination li.active {
	padding: 7px;
	border-radius: 20px;
	background-color: #ff4343;
	height: 40px;
	width: 40px;
}

.pager .pagination li.active a {
	color: #fff;
	font-weight: bolder;
}

input:focus,
textarea:focus,
button:focus {
	outline-width: 0;
}
</style>
